import { render } from "./InvalidRecovery.vue?vue&type=template&id=4e831092&scoped=true"
import script from "./InvalidRecovery.vue?vue&type=script&lang=js"
export * from "./InvalidRecovery.vue?vue&type=script&lang=js"

import "./InvalidRecovery.vue?vue&type=style&index=0&id=4e831092&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e831092"]])

export default __exports__